import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AvailableLanguages, EN_DATE_FORMAT_CLASIC, IT_DATE_FORMAT_CLASSIC } from '@pt/pt-models';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'localizedDate',
  pure: false
})
export class LocalizedDatePipe implements PipeTransform {

  constructor(private translateService: TranslateService) {
  }

  private get currentPattern() {
    switch (this.translateService.currentLang) {
      case AvailableLanguages.en:
        return EN_DATE_FORMAT_CLASIC;
      case AvailableLanguages.it:
        return IT_DATE_FORMAT_CLASSIC;
      default:
        return EN_DATE_FORMAT_CLASIC;
    }
  }

  transform(value: any, options: { pattern?: string, defaultValue?: string } = null): any {
    const pattern = options?.pattern ? options.pattern : this.currentPattern;
    const defaultValue = options?.defaultValue ? options.defaultValue : '';
    const datePipe: DatePipe = new DatePipe(this.translateService.currentLang);
    const localizedDate = datePipe.transform(value, pattern);
    return localizedDate ? localizedDate : defaultValue;

    // if (value) {
    //   const date = new Date(value);
    //   const day = String(date.getDate()).padStart(2, '0');
    //   const month = String(date.getMonth() + 1).padStart(2, '0'); // I mesi sono indicizzati da 0
    //   const year = date.getFullYear();
    //   switch (this.translateService.currentLang) {
    //     case AvailableLanguages.en:
    //       return `${month}/${day}/${year}`;
    //     case AvailableLanguages.it:
    //     default:
    //       return `${day}/${month}/${year}`;
    //   }
    // }
    // return options?.defaultValue ? options.defaultValue : '';
  }

}
